import _Button from "@mui/material/Button";
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import { styled } from 'styled-components';
export function Button({
  ...props
}) {
  return /*#__PURE__*/React.createElement(StyledButton, _extends({
    size: "small"
  }, props));
}
const StyledButton = styled(_Button)`
  && {
    border-radius: 1000px;
    text-transform: initial;
  }

  &.MuiButton-contained:not(.MuiButton-containedPrimary):not(.MuiButton-containedSecondary):not(
      .dangerous
    ) {
    background-color: #fff;
  }
`;